module.exports = __webpack_public_path__ + "img/hr-sand-decal-15.e22f32c3.png";